import backend from './backend';

const endpoint = '/collections';

export default {
    get(){
        return backend.get(endpoint).then(response => response.data)
    },
    getByTitle(title){
        return backend.get(endpoint + '?title=' + title)
    },
    create(title){
        return backend.post(endpoint, {title: title})
    },
    async getOrCreateCollectionByTitle(title){
        const collections = await this.getByTitle(title)
        if(collections.data.length === 0) {
            return this.create(title)
        } else {
            return collections.data[0]
        }
    }

}